import { ALLOW_WS_OVERRIDE, MM_WS_QS_KEY, MM_WS_SS_KEY, MM_WS_URL } from '@skynet/config-provider';

import { createWsConnect } from '@skynet/data-ws-core';

import { prefix } from './actions';

/**
 * Resolves the MM WebSocket URL from query-string, sessionStorage, or the
 * default env value, then dispatches a `connect` action for the MM channel.
 *
 * @example
 * store.dispatch(wsMmConnect());
 */
export const wsMmConnect = createWsConnect(prefix, {
  defaultUrl: MM_WS_URL,
  ssKey: MM_WS_SS_KEY,
  qsKey: MM_WS_QS_KEY,
  allowOverride: ALLOW_WS_OVERRIDE,
});
